import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { PostcodeAreasService } from "./postcodeareas.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { PostcodeArea } from "../../api-models/PostcodeArea";
import { PostcodeAreasMainComponent } from "./postcodeareas.main.component";

@Component({
    selector: "app-postcodeareas",
    templateUrl: "./postcodeareas.component.html",
    styleUrls: ["postcodeareas.component.scss"],
    standalone: false
})
export class PostcodeAreasComponent extends BaseMaterialDatatableComponent<PostcodeArea> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: PostcodeArea[] = [];

    constructor(
        private postcodeAreasService: PostcodeAreasService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: PostcodeAreasMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: postcodeAreasService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_postcodeareas_list",
            },
            sortState: {
                active: "created",
                direction: "asc",
            },
            displayedColumns: ["postcodeStart", "postcodeEnd", "created", "updated", "actions"],
            listService: postcodeAreasService,
        });

        this.UTCDATEFORMAT = this.postcodeAreasService.UTCDATEFORMAT;
    }

    addPostcodeArea() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editPostcodeArea(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deletePostcodeArea(id: string) {
        const initialState = {
            title: this.translateService.instant("postcodeareas.list.delete.title"),
            message: this.translateService.instant("postcodeareas.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.postcodeAreasService.deletePostcodeArea(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("postcodeareas.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }
}
